// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__T0psY"};